<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21.89 21.91"
  >
    <path
      :style="{
        fill: color
      }"
      d="M951,550.07a4,4,0,0,1-.74-.07.47.47,0,0,1-.39-.34.51.51,0,0,1,.12-.51l.11-.1h0a.5.5,0,0,1-.34-.13l-.32-.29a.5.5,0,0,1-.13-.54l5.08-13.64a1.88,1.88,0,0,1,1.31-1.24c1.44-.43,3-.94,4.77-1.54a1.69,1.69,0,0,1,.59-.11,1.48,1.48,0,0,1,1.09.51c1.44,1.47,3.16,3.21,4.92,4.91a1.56,1.56,0,0,1,.4,1.79c-.47,1.4-1,3-1.46,4.54a2.17,2.17,0,0,1-1.5,1.51l-3.47,1.3c-1.77.67-3.6,1.36-5.42,2a10.64,10.64,0,0,0-2,1l-.91.52A3.5,3.5,0,0,1,951,550.07Zm8.19-12.16a2,2,0,0,0-1,.27,2,2,0,0,0-.93,2.51A1.17,1.17,0,0,1,957,542l-3.84,4,3.83-3.79a1.31,1.31,0,0,1,1-.45,1.84,1.84,0,0,1,.56.1,2.68,2.68,0,0,0,.72.11,1.93,1.93,0,0,0,1.7-1,2,2,0,0,0-.37-2.46A2,2,0,0,0,959.14,537.91Z"
      transform="translate(-948.71 -528.66)"
    />
    <path
      class="cls-2"
      d="M961,532.06a1,1,0,0,1,.74.36c1.62,1.66,3.26,3.31,4.93,4.92a1,1,0,0,1,.26,1.27c-.5,1.52-1,3-1.46,4.56a1.67,1.67,0,0,1-1.19,1.18c-3,1.08-5.9,2.26-8.89,3.28a20,20,0,0,0-2.94,1.54,3,3,0,0,1-1.49.4,4,4,0,0,1-.66-.06c2.4-2.36,4.72-4.64,7-6.93a.81.81,0,0,1,.6-.3,1.46,1.46,0,0,1,.42.08,3,3,0,0,0,.86.13,2.51,2.51,0,0,0,1.68-4.34,2.47,2.47,0,0,0-1.74-.74,2.56,2.56,0,0,0-1.24.33,2.46,2.46,0,0,0-1.17,3.08c.11.36.14.56-.12.84q-3.3,3.44-6.58,6.89l-.32-.29q2.53-6.81,5.08-13.64a1.41,1.41,0,0,1,1-.93c1.61-.48,3.21-1,4.8-1.55a1.11,1.11,0,0,1,.42-.08m0-1a2.32,2.32,0,0,0-.75.13c-1.76.61-3.31,1.11-4.75,1.54a2.38,2.38,0,0,0-1.64,1.55q-2,5.29-4,10.6l-1.13,3A1,1,0,0,0,949,549l.16.15.12.11a1,1,0,0,0,0,.55,1,1,0,0,0,.78.68,4.08,4.08,0,0,0,.83.08,4,4,0,0,0,2-.52l.93-.53a10.23,10.23,0,0,1,1.87-.94c1.83-.63,3.66-1.32,5.44-2,1.15-.44,2.3-.88,3.46-1.3a2.68,2.68,0,0,0,1.81-1.83c.44-1.47.92-2.92,1.45-4.53a2,2,0,0,0-.52-2.31c-1.75-1.69-3.46-3.42-4.91-4.9a2,2,0,0,0-1.45-.66Zm-3.18,10.23a2.63,2.63,0,0,0-.11-.74,1.45,1.45,0,0,1,.68-1.93,1.53,1.53,0,0,1,.76-.21,1.5,1.5,0,0,1,1.05.46,1.47,1.47,0,0,1,.28,1.85,1.43,1.43,0,0,1-1.27.77,2.05,2.05,0,0,1-.58-.09,2.45,2.45,0,0,0-.7-.12Z"
      transform="translate(-948.71 -528.66)"
    />
    <path
      :style="{
        fill: color
      }"
      d="M967.78,537.25a.52.52,0,0,1-.36-.14l-5.35-5.37a.5.5,0,0,1-.09-.58,1,1,0,0,1,.22-.38c1.07-1.07,1.61-1.61,2.31-1.61s1.24.54,2.32,1.62l.8.81c.58.59,1.19,1.21,1.82,1.78a1.66,1.66,0,0,1,.65,1.21,1.7,1.7,0,0,1-.69,1.2,11.09,11.09,0,0,0-.84.84l-.43.47a.49.49,0,0,1-.36.15Z"
      transform="translate(-948.71 -528.66)"
    />
    <path
      class="cls-2"
      d="M964.51,529.66c.49,0,1,.5,2,1.48s1.72,1.78,2.63,2.61c.68.62.63,1.09,0,1.66-.45.39-.83.85-1.3,1.34-1.85-1.84-3.59-3.59-5.35-5.36a.63.63,0,0,1,.13-.26c1-1,1.46-1.47,2-1.47m0-1h0c-.91,0-1.53.63-2.66,1.77a1.39,1.39,0,0,0-.33.54h0a1,1,0,0,0,.2,1.14l4.89,4.9.46.46a1,1,0,0,0,.71.29h0a1,1,0,0,0,.71-.3l.44-.48a10,10,0,0,1,.79-.8,2.21,2.21,0,0,0,.87-1.57,2.12,2.12,0,0,0-.82-1.59c-.61-.56-1.22-1.18-1.81-1.78l-.78-.79c-1.15-1.15-1.78-1.78-2.68-1.78Z"
      transform="translate(-948.71 -528.66)"
    />
  </svg>
</template>

<script>
import { Pinning } from "@/utils/Pinning";

export default {
  name: "IconPen",
  mixins: [Pinning],
  props: {
    colorLabel: {
      type: String,
      required: false
    }
  },
  computed: {
    color() {
      return this.getPinPickerColor(this.colorLabel);
    }
  }
};
</script>

<style scoped>
.cls-2 {
  fill: #fff;
}
</style>
